/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.reports.list', {
      url: '/list?bucket&reportId',
      template: '<report-list></report-list>',
      params: {
        bucket: { dynamic: true, inherit: false, value: null },
        reportId: { dynamic: true, inherit: false, value: null },
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/reports/list/list.routes.js